import React from 'react';
import {useStrings} from '@zvne/fe-framework/dist/presentation/language/strings';
import {strings} from './strings';

export function ErrorScreen() {
    const s = useStrings(strings);
    return (
        <>
            <h1>{s.header}</h1>
            <p>{s.text}</p>
        </>
    );
}
